import React from "react";
import { motion } from "framer-motion";

import p1 from "../assets/projects/project1.png";
import p2 from "../assets/projects/project2.png";
import p3 from "../assets/projects/project3.png";
import p4 from "../assets/projects/project4.png";
import p5 from "../assets/projects/project5.png";
import p6 from "../assets/projects/project6.png";
import p7 from "../assets/projects/project7.png";
import p8 from "../assets/projects/project8.png";
import p9 from "../assets/projects/project9.png";
import p10 from "../assets/projects/project10.png";
import p11 from "../assets/projects/project11.png";
import p12 from "../assets/projects/project12.png";
import p13 from "../assets/projects/project13.png";
import p14 from "../assets/projects/project14.png";
import p15 from "../assets/projects/project15.png";
import p16 from "../assets/projects/project16.png";
import p17 from "../assets/projects/project17.png";
import p18 from "../assets/projects/project18.png";
import { HoverImageLinks } from "./projectDetails";

export default function Projects() {
  const project = [
    {
      id: 1,
      img: p1,
      lnk: "https://rishabhtripathymusic.vercel.app/",
      title: "My Artist Profile",
      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "Next.js",
        "TypeScript",
        "Tailwind CSS",
        "Framer Motion"
      ]
    },
    {
      id: 2,
      img: p2,
      lnk: "https://www.pagodacenturion.com/",
      title: "Pagoda Centurion",
      desc: ["HTML", "CSS", "JavaScript", "Next.js", "Tailwind CSS", "AOS"]
    },
    {
      id: 3,
      img: p3,
      lnk: "https://justhomestay.in/",
      title: "Just Home Stay",
      desc: ["HTML", "CSS", "JavaScript", "Next.js", "Tailwind CSS", "AOS"]
    },
    {
      id: 4,
      img: p4,
      lnk: "https://scoreme.in/",
      title: "ScoreMe",

      desc: ["HTML", "CSS", "JavaScript", "Next.js", "Tailwind CSS"]
    },
    {
      id: 5,
      img: p5,
      lnk: "https://www.resurgentindia.com/",
      title: "Resurgent Legal",
      desc: ["HTML", "CSS", "JavaScript", "Next.js", "Tailwind CSS"]
    },
    {
      id: 6,
      img: p6,
      lnk: "https://theahomesmanali.com/",
      title: "The Thea Homes",

      desc: ["HTML", "CSS", "JavaScript", "Next.js", "Tailwind CSS", "AOS"]
    },
    {
      id: 7,
      img: p7,
      lnk: "https://gurugramplot.com/",
      title: "The Gurugram Plot",
      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "NocoDb",
        "Next.js",
        "Tailwind CSS",
        "AOS",
        "Swift API"
      ]
    },
    {
      id: 8,
      img: p8,
      lnk: "https://www.reyarpgreen.com/",
      title: "REY ARP NIGERIA LIMITED",
      desc: ["HTML", "CSS", "Wix"]
    },
    {
      id: 9,
      img: p9,
      lnk: "https://moochuu.in/",
      title: "Moo Chuu India",
      desc: ["HTML", "CSS", "Shopify"]
    },
    {
      id: 10,
      img: p10,
      lnk: "https://abbyevents.in/",
      title: "Abby Events",
      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "Wordpress",
        "Tailwind CSS",
        "Next Js"
      ]
    },
    {
      id: 11,
      img: p11,
      lnk: "https://suncitystudios.in/",
      title: "Suncity Studios",

      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "React",
        "Tailwind CSS",
        "Framer Motion",
        "Strapi"
      ]
    },
    {
      id: 12,
      img: p12,
      lnk: "https://moonshotmedia.in/",
      title: "Moonshot Media",
      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "React",
        "Tailwind CSS",
        "Framer Motion",
        "Strapi"
      ]
    },
    {
      id: 13,
      img: p13,
      lnk: "https://www.flychicken.in/",
      title: "Fly Chicken India",
      desc: ["HTML", "CSS", "JavaScript", "Webflow"]
    },
    {
      id: 14,
      img: p14,
      lnk: "https://terragrande.in/",
      title: "Terra Grande by Eldeco",
      desc: ["HTML", "CSS", "JavaScript", "Wordpress"]
    },
    {
      id: 15,
      img: p15,
      lnk: "https://www.perona.com/",
      title: "Perona",
      desc: ["HTML", "CSS", "JavaScript", "Shopify"]
    },
    {
      id: 16,
      img: p16,
      lnk: "https://akshitarattha.com/",
      title: "Akshita Rattha",
      desc: ["HTML", "CSS", "JavaScript", "Shopify"]
    },
    {
      id: 17,
      img: p17,
      lnk: "https://weareogatu.com/",
      title: "Ogatu",
      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "Next Js",
        "Tailwind Css",
        "Framer Motion"
      ]
    },
    {
      id: 18,
      img: p18,
      lnk: "https://beamandwords.com/",
      title: "Beam And Words",
      desc: [
        "HTML",
        "CSS",
        "JavaScript",
        "Next Js",
        "Tailwind Css",
        "Framer Motion"
      ]
    }
  ];

  return (
    <div
      name="projects"
      className=" w-full h-full pt-16 md:pt-32 px-4  text-white "
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full ">
        <div className="">
          <motion.p
            initial={{
              opacity: 0
            }}
            whileInView={{
              opacity: 1
            }}
            transition={{
              delay: 0.2
            }}
            className=" text text-3xl uppercase font-jost font-bold inline border-b-4 border-gray-300 bg-gradient-to-r from-cyan-500 to-blue-600 bg-clip-text text-transparent "
          >
            Projects
          </motion.p>
        </div>
        <motion.div
          initial={{
            opacity: 0
          }}
          whileInView={{
            opacity: 1
          }}
          transition={{
            delay: 0.3,
            duration: 1
          }}
          className="hidden lg:block"
        >
          <HoverImageLinks project={project} />
        </motion.div>
        <motion.div
          initial={{
            opacity: 0
          }}
          whileInView={{
            opacity: 1
          }}
          transition={{
            delay: 0.3,
            duration: 1
          }}
          className="text-xl grid md:grid-cols-3 lg:hidden gap-8 grid-cols-1 mt-10 "
        >
          {project.reverse().map((item, id) => (
            <div
              key={id}
              className="card w-auto  shadow-md hover:scale-110 group duration-700 shadow-blue-900 flip-card-inner  flip-card-front image-full"
            >
              <figure className="">
                <img src={item.img} alt="Shoes" className="" />
              </figure>
              <div className="card-body  shadow-xl text-center  ">
                <h2 className="card-title justify-center group-hover:text-white duration-700 font-jost">
                  {item.title}
                </h2>
                <div className="grid grid-cols-3 gap-2 mt-2 group-hover:text-white duration-700">
  {item.desc.map((skill, index) => (
    <span
      key={index}
      className="px-3 py-1 text-sm font-semibold bg-blue-600 text-white rounded-full text-center"
    >
      {skill}
    </span>
  ))}
</div>

                <div className="card-actions justify-center mt-8">
                  <a
                    href={item.lnk}
                    target="_blank"
                    rel="noreferrer"
                    className="btn group-hover:scale-125 hover:text-white duration-300  btn-circle"
                  >
                    View Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
